import { injectIntl, IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import { get, isEmpty } from 'lodash';
import { useEffect } from 'react';
import { Avatar, Box, Grid, Paper, Typography } from '@material-ui/core';
import SahamDrawer from 'components/SahamDrawer';
import { SagisConfig } from 'containers/AppContainer/typings';
import emptyBox from 'images/emptyBox.svg';
import {
  EmptyBlocContainer,
  Container,
} from 'containers/CourtManagerLegalProceedings/InstructionDrawer/styled-components';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import sanlamIcon from 'images/icon-sanlam.png';
import { isCurrentUser } from 'containers/CourtManagerLegalProceedings/InstructionDrawer/utils';
import currentUserStorage from 'containers/services/security/current-user-storage';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { INSTRUCTION } from 'containers/CourtManagerLegalProceedings/InstructionDrawer/data-structure';
import { ClaimRecapType } from 'typings/claimTypes';
import { InstructionType } from 'typings/globalTypes';

export interface InstructionDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  listings: any;
  judiciaryProcess: any;
  intervenants: SagisConfig[];
  claimRecap: ClaimRecapType;
  setIsInstructionDrawerOpen: Function;
  judiciaryProcessId?: number;
  isConsultation: Boolean;
  instructions: InstructionType[];
  requestCreateInstruction: Function;
  requestGetInstructions: Function;
  isManager: Boolean;
  claimId: number;
  instruction: string;
  setInstruction: Function;
  isIntervenant: boolean;
}

const InstructionDrawer: React.FC<InstructionDrawerProps> = (
  props,
): JSX.Element => {
  useEffect(() => {
    if (props.claimId) {
      featureService.hasFeature(FEATURES.INSTRUCTIONS) &&
        props.judiciaryProcessId &&
        props.requestGetInstructions({
          judiciaryProcessId: props.judiciaryProcessId,
        });
    }
  }, [!props.claimId, props.judiciaryProcessId]);
  const handleValidateDrawer = () => {
    props.requestCreateInstruction(
      {
        text: props.instruction,
        judiciaryProcessId: props.judiciaryProcessId,
        isManager: !props.isIntervenant ? props.isManager : false,
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        lawyerCode: props.isIntervenant
          ? currentIntervenantStorage.get()?.sagis_code
          : null,
        claimId: props.claimId,
        isLawyer: props.isIntervenant,
        createdBy: props.isIntervenant
          ? currentIntervenantStorage.get()?.preferred_username
          : get(currentUserStorage.get()?.privileges, 'sagisName'),
      },
      successCallBack,
    );
  };
  const successCallBack = () => {
    toast.success(translate(messages.toastSucess, props));
    props.requestGetInstructions({
      judiciaryProcessId: props.judiciaryProcessId,
    });
    props.setInstruction('');
  };
  const handleChange = (
    event: React.ChangeEvent<{
      value: string;
    }>,
  ) => {
    const { value } = event.target;
    props.setInstruction(value);
  };
  const getFormattedDate = (value: any) => {
    const date = new Date(value);
    const formattedDate = date.toLocaleString('fr-FR', {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });
    return formattedDate;
  };
  const sagisCode = currentIntervenantStorage.get()?.sagis_code;
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate({ ...messages.instructionTitle }, props)}
      isInstruction={
        (props.isManager || props.isIntervenant) && !props.isConsultation
      }
      isDisplayCancelButton={false}
      handleValidateDrawer={handleValidateDrawer}
      handleChange={handleChange}
      value={props.instruction}
      isDisplayCloseButton={true}
    >
      {isEmpty(props.instructions) ? (
        <EmptyBlocContainer>
          <img src={emptyBox} alt="empty box" />
          <span className="bloc-title">
            {translate(messages.noDataTitle, props)}
          </span>
        </EmptyBlocContainer>
      ) : (
        <>
          {props.instructions.map((item: any) => {
            return (
              <Container key={item.id}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    className="typography-date"
                    gutterBottom
                  >
                    {getFormattedDate(get(item, 'createdAt'))}
                  </Typography>
                  {!isCurrentUser(item, props.isManager, sagisCode) ? (
                    <Box className="box-content">
                      <Avatar
                        src={sanlamIcon}
                        alt="User Avatar"
                        className="icon-avatar"
                      />
                      <Box className="box-name">
                        <Grid>
                          <Typography className="typography-title">
                            {get(item, INSTRUCTION.CREATED_BY)}
                          </Typography>
                        </Grid>
                        <Paper className={'paper-box'}>
                          <Typography variant="body2">
                            {get(item, INSTRUCTION.TEXT)}
                          </Typography>
                        </Paper>
                      </Box>
                    </Box>
                  ) : (
                    <Grid
                      container
                      style={{
                        marginBottom: 10,
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        padding: 15,
                      }}
                    >
                      <Grid item>
                        <Box className="box-content">
                          <Box className="box-name">
                            <Paper className={'paper-box own-text'}>
                              <Typography variant="body2">
                                {get(item, INSTRUCTION.TEXT)}
                              </Typography>
                            </Paper>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                </Box>
              </Container>
            );
          })}
        </>
      )}
    </SahamDrawer>
  );
};
export default injectIntl(InstructionDrawer);
